export default __webpack_public_path__ + "static/media/amazon.17592bd6.png";